export enum ContextMenuItemType {
    Checkbox,
}
